import { createAsyncThunk } from "@reduxjs/toolkit";
import trainingPeriodService from "../services/trainingPeriodService";
import { toast } from "react-toastify"; // Updated import
import { toastMessages, toastOptions } from "../config/toastifyConfig";
import TrainingPeriod from "../types/TrainingPeriod";

// Async Thunks

// Load Single Training Period
export const loadSingleTrainingPeriod = createAsyncThunk(
  "trainingPeriods/loadSingleTrainingPeriod",
  async (periodId: number, { rejectWithValue }) => {
    try {
      const trainingPeriod = await trainingPeriodService.getById(periodId);

      // Updated toast notification
      toast.success(toastMessages.trainingPeriodLoaded, toastOptions);

      return trainingPeriod;
    } catch (error) {
      toast.error(toastMessages.trainingPeriodLoadError, toastOptions); // Updated error handling
      return rejectWithValue(error);
    }
  }
);

// Add Training Period
export const addTrainingPeriod = createAsyncThunk(
  "trainingPeriods/addTrainingPeriod",
  async (trainingPeriodToSave: TrainingPeriod, { rejectWithValue }) => {
    try {
      const trainingPeriod = await trainingPeriodService.add(trainingPeriodToSave);

      // Updated toast notification
      toast.success(toastMessages.trainingPeriodSaved, toastOptions);

      return trainingPeriod;
    } catch (error) {
      toast.error(toastMessages.trainingPeriodSaveError, toastOptions); // Updated error handling
      return rejectWithValue(error);
    }
  }
);

// Update Training Period
export const updateTrainingPeriod = createAsyncThunk(
  "trainingPeriods/updateTrainingPeriod",
  async (trainingPeriodToUpdate: TrainingPeriod, { rejectWithValue }) => {
    try {
      const updatedTrainingPeriod = await trainingPeriodService.update(trainingPeriodToUpdate);

      // Updated toast notification
      toast.success(toastMessages.trainingPeriodUpdated, toastOptions);

      return updatedTrainingPeriod;
    } catch (error) {
      toast.error(toastMessages.trainingPeriodUpdateError, toastOptions); // Updated error handling
      return rejectWithValue(error);
    }
  }
);

// Delete Training Period
export const deleteTrainingPeriod = createAsyncThunk(
  "trainingPeriods/deleteTrainingPeriod",
  async (periodIdToDelete: number, { rejectWithValue }) => {
    try {
      await trainingPeriodService.deleteById(periodIdToDelete);

      // Updated toast notification
      toast.success(toastMessages.trainingPeriodDeleted, toastOptions);

      return periodIdToDelete;
    } catch (error) {
      toast.error(toastMessages.trainingPeriodDeleteError, toastOptions); // Updated error handling
      return rejectWithValue(error);
    }
  }
);
